var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('embed-api-table',{attrs:{"title":"Keyword Search Result Screenshots","module":"Search-Results","refresh-for-id":_vm.refreshId,"default-sort":"createdAt DESC","columns":_vm.screenshotColumns,"fields":_vm.screenshotFields,"filter":_vm.screenshotFilter},on:{"click":_vm.resultClicked}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff39b678","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissingLinkTable.vue
// module id = null
// module chunks = 